import { createSlice } from '@reduxjs/toolkit';

import * as routes from 'router/routes';
import { navigate } from 'router/navigation';

const initialState = {
  currentUser: null,
};

export const usersSlice = createSlice({
  name: 'usersSlice',
  initialState,
  reducers: {
    logout: {
      reducer: () => initialState,
      prepare: (redirectTo = routes.loginScreen) => {
        localStorage.clear();
        navigate(redirectTo);

        return {};
      },
    },
    setCurrentUser: (state, action) => ({
      ...state,
      currentUser: action.payload,
    }),
  },
});

export const { logout } = usersSlice.actions;
